import { Nullable } from '@client/core/data/types';
import { Attachment } from '@client/features/project-documents/models/attachment';
import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';
import { JsonResponse } from '@client/core/data/concerns/parses-from-json/types';
import { fromJson } from '@client/core/data/concerns/parses-from-json/from-json';
import { CompanyInvestmentPacketData } from '@client/features/company-profile/models/company-investment-packet-data';

/**
 * Company that is used for a Workspace Company Profile
 *
 * @see app/CompanyProfileResource.php
 */
export class CompanyProfile {
  constructor(
    public readonly id: number,
    public readonly uuid: string,
    public readonly name: string,
    public readonly email: Nullable<string>,
    public readonly phone: Nullable<string>,
    public readonly website: Nullable<string>,
    public readonly logo: Nullable<Attachment>,
    // Do not believe the editor if it says this is not used.
    // @see client/features/company-profile/CompanyProfileApp.vue
    public readonly navbarLogo: Nullable<Attachment>,
    public readonly packetData: CompanyInvestmentPacketData,
  ) {}
}

defineTransform(CompanyProfile, (json: JsonResponse, { fromSnakeCaseKeys }) => {
  return {
    ...fromSnakeCaseKeys(),
    logo: json.logo ? fromJson(Attachment, json.logo) : null,
    navbarLogo: json.navbar_logo ? fromJson(Attachment, json.navbar_logo) : null,
    packetData: fromJson(CompanyInvestmentPacketData, json.packet_data),
  };
});
